module.exports = __webpack_public_path__ + "img/q2.1_2022.e226ecc2.png";